class Legaltext {
  constructor() {
    this.PRICE = '##PRICE##';
    this.EDIT = '##EDIT##';
    this.canvasPainted = false;
  }

  // RECORREM TOTS els textos legals i els anem omplint segons el seu tipus
  addLegalTexts() {
    let self = this;
    let legaltext_data = [];
    $('.all-legaltext-container').find('.legaltext-container').each(function(index, currentLegal) {
      let newLegal = {
        id: $('.all-legaltext-container').find(currentLegal).data('legalid'),
        values: $('.all-legaltext-container').find(currentLegal).find('.legaltext-label').html(),
        type: $('.all-legaltext-container').find(currentLegal).data('type'),
        importer_id: $('.all-legaltext-container').find(currentLegal).data('importerid')
      };
      // Si el legal text te un camp variable de tipus input
      // l'haurem de substituir pel valor
      let editableInputs = $('.all-legaltext-container').find(currentLegal).find('.legal-text-input--' + newLegal.id);
      if (editableInputs.length > 0) {
        newLegal.values = self.transformInputsToValues(currentLegal, editableInputs, newLegal.id);
      }
      switch (newLegal.type) {
        case 1:
          // LECTURA (no fem res)
        break;
        case 2:
        case 3:
          // CHECKBOX
          newLegal.selected = $('.all-legaltext-container').find(currentLegal).find('#legaltext--' + newLegal.id).prop('checked') ? 1 : 0;
        break;
        case 5:
        case 7:
          // MULTIOPCIONS (radio) excepte checks "totes les opcions"
          var optionsArray = [];
          $('.all-legaltext-container').find(currentLegal).find('.legaltext-options-group--' + newLegal.id + ' input').each(function(index, option) {
            if (!$('.all-legaltext-container').find(currentLegal).find(option).hasClass('check_all_options')) {
              var newOption = {
                id: $('.all-legaltext-container').find(currentLegal).find(option).data('optionid'),
                selected: $('.all-legaltext-container').find(currentLegal).find(option).prop('checked') ? 1 : 0,
                values: $('.all-legaltext-container').find(currentLegal).find(option).parent().find('.legaltext-label-option').html()
              };
              // Busquem i substituim tots els valors de camps variables
              var editableInputs = $('.all-legaltext-container').find(currentLegal).find('.legal-text-input--' + newOption.id);
              if (editableInputs.length > 0) {
                newOption.values = self.transformInputsToValues(currentLegal, editableInputs, newOption.id);
              }
              if (newOption.id) {
                optionsArray.push(newOption);
              }
            }
            newLegal.options = optionsArray;
          });
        break;
        case 4:
        case 8:
          // MULTIOPCIONS (radio)
          var optionsArray = [];
          $('.all-legaltext-container').find(currentLegal).find('.legaltext-options-group--' + newLegal.id + ' input').each(function(index, option) {
            var newOption = {
              id: $('.all-legaltext-container').find(currentLegal).find(option).data('optionid'),
              selected: $('.all-legaltext-container').find(currentLegal).find(option).prop('checked') ? 1 : 0,
              values: $('.all-legaltext-container').find(currentLegal).find(option).siblings('.legaltext-label-option').html()
            };
            // Busquem i substituim tots els valors de camps variables
            var editableInputs = $('.all-legaltext-container').find(currentLegal).find('.legal-text-input--' + newOption.id);
            if (editableInputs.length > 0) {
              newOption.values = self.transformInputsToValues(currentLegal, editableInputs, newOption.id);
            }
            if (newOption.id) {
              optionsArray.push(newOption);
            }
          });
          newLegal.options = optionsArray;
        break;
        case 6:
          // TEXTAREA - fill values
          newLegal.values = $('.all-legaltext-container').find(currentLegal).find('#legaltext--' + newLegal.id).val();
        break;
        case 9:
        case 10:
          // FIRMA - fill signature
          newLegal.signature = document.getElementById('sig-canvas--' + newLegal.id).toDataURL();
        break;
      }
      // Posem el legal text recorregut
      legaltext_data.push(newLegal);
    });
    return legaltext_data;
  }


  setPriceVar() {
    // Replace PRICE (preu total)
    let legalText = $('.all-legaltext-container').find('.all-legaltext-container .legaltext-price-var');
    if (legalText.length === 0) {
      legalText = $('.all-legaltext-container').find('.legaltext-container');
    }
    let price = '<span class="legaltext-price-var">' + $('.all-legaltext-container').find('#action_estimate_price_modified .number').html() + '</span>';
    let stringToReplace = '';
    let intIndexOfMatch = -1;
    let textReplaced = false;
    for (let i = 0; i < legalText.length; i += 1) {
      stringToReplace = $('.all-legaltext-container').find(legalText[i]).html();
      intIndexOfMatch = stringToReplace.indexOf(this.PRICE);
      while (intIndexOfMatch != -1) {
        stringToReplace = stringToReplace.replace(this.PRICE, price);
        intIndexOfMatch = stringToReplace.indexOf(this.PRICE);
        textReplaced = true;
      }
      if (textReplaced) {
        $('.all-legaltext-container').find(legalText[i]).html(stringToReplace);
      }
    }
    this.assignSignEvents();
  }

  resetPriceVar() {
    // Replace Preu total per la variable (invers)
    let legalText = $('.all-legaltext-container').find('.all-legaltext-container .legaltext-price-var');
    let priceToReset = $('.all-legaltext-container').find('#action_estimate_price_modified .number').html();
    let stringToReplace = '';
    for (let i = 0; i < legalText.length; i += 1) {
      stringToReplace = $('.all-legaltext-container').find(legalText[i]).html();
      stringToReplace = stringToReplace.replace(priceToReset, this.PRICE);
      $('.all-legaltext-container').find(legalText[i]).html(stringToReplace);
    }
  }

  transformInputsToValues(currentLegal, items, itemId) {
    let newValues = '';
    for (let i = 0; i < items.length; i += 1) {
      if (newValues !== '') {
        newValues += ' || ';
      }
      let currentInput = $('.all-legaltext-container').find(currentLegal).find('.legal-text-input--' + itemId)[i];
      newValues += $('.all-legaltext-container').find(currentLegal).find(currentInput).val();
    }
    return newValues;
  }

  // Recorrem tots els textos legals requerits de la pagina
  // Si estan tots marcats com a required = 0 es que ja s'han omplert
  hasPageRequired(pageView) {
    let requiredLegalTexts = pageView.find('.legaltext-container.required');
    if (requiredLegalTexts === 0) {
      return false;
    }
    for (let i = 0; i < requiredLegalTexts.length; i += 1) {
      if ($('.all-legaltext-container').find(requiredLegalTexts[i]).attr('data-required') === "1") {
        return true;
      }
    }
    return false;
  }

  // Recorrem totes les pagines per veure si tenen els textos legals contestats
  // i així poder tornar a re-activar també l'ultim button
  hasLegalRequired() {
    let requiredLegalTexts = $('.all-legaltext-container').find('.legaltext-page');
    for (let i = 0; i < requiredLegalTexts.length; i += 1) {
      if ($('.all-legaltext-container').find(requiredLegalTexts[i]).attr('data-required') === "1") {
        return true;
      }
    }
    return false;
  }

  checkValidateButton(legalTextId) {
		let pageView = $('.all-legaltext-container').find('#sig-canvas--' + legalTextId).parents('.legaltext-page');
		let legalText = $('.all-legaltext-container').find('.legaltext-container--' + legalTextId);
		let nextLink = pageView.find('.js-next-legalpage');
		let lastLink = $('.all-legaltext-container').find('.js-final-legal');
		if (nextLink.length === 0) {
			nextLink = pageView.find('.js-final-legal');
		}
		let i = 0;
		let painted = 0;
		pageView.find('.sig-legaltext-canvas').each(function(e) {
      //Només comptem els que tenen signatura obligatòria (tipus 9)
      if ($(this).parents('.legaltext-container').attr('data-type') == 9) {
  			let legalTextId = $('.all-legaltext-container').find(this).data('legaltextid');
  			let canvas = document.getElementById('sig-canvas--'+legalTextId);
  			if (canvas.getAttribute('painted') === "1"){
  				painted = painted + 1;
  			}
  			i = i + 1;
      }
		});
    if (legalText.attr('data-original-required') == undefined) {
      legalText.attr('data-original-required', legalText.attr('data-required'));
    }
		legalText.attr('data-required', 0);
		// Si tots els textos legals de tipus firma estan actius es pot activar el button
		if (i === painted) {
			// Tambe han d'estar acceptats la resta de textos legals
			if (!this.hasPageRequired(pageView)) {
				pageView.attr('data-required', 0);
				nextLink.attr('disabled', false);
				nextLink.removeClass('disabled');
				if (!this.hasLegalRequired()) {
					lastLink.attr('disabled', false);
					lastLink.removeClass('disabled');
					lastLink.addClass('active');
				}
			}
		} else {
			pageView.attr('data-required', 1);
			nextLink.attr('disabled', true);
			nextLink.addClass('disabled');
			lastLink.removeClass('active');
		}
	}

  assignSignEvents() {
    let self = this;
		$('.all-legaltext-container').find('.sig-legaltext-canvas').each(function() {
			let legalTextId = $('.all-legaltext-container').find(this).data('legaltextid');
			let canvas = document.getElementById('sig-canvas--'+legalTextId);
			let ctx = canvas.getContext("2d");
			ctx.strokeStyle = "#000";
			ctx.lineWith = 1;
	
			// Set up mouse events for drawing
			let drawing = false;
			let mousePos = { x:0, y:0 };
			let lastPos = mousePos;
			canvas.addEventListener("mousedown", function (e) {
				drawing = true;
				self.canvasPainted = true;
				canvas.setAttribute('painted','1');
				self.checkValidateButton(legalTextId);
				lastPos = getMousePos(canvas, e);
			}, false);
			canvas.addEventListener("mouseup", function (e) {
				drawing = false;
			}, false);
			canvas.addEventListener("mousemove", function (e) {
				mousePos = getMousePos(canvas, e);
			}, false);
	
			// Get the position of the mouse relative to the canvas
			function getMousePos(canvasDom, mouseEvent) {
				let rect = canvasDom.getBoundingClientRect();
				return {
					x: mouseEvent.clientX - rect.left,
					y: mouseEvent.clientY - rect.top
				};
			}
			
			// Get a regular interval for drawing to the screen
			window.requestAnimFrame = (function (callback) {
				return window.requestAnimationFrame || 
				window.webkitRequestAnimationFrame ||
				window.mozRequestAnimationFrame ||
				window.oRequestAnimationFrame ||
				window.msRequestAnimaitonFrame ||
				function (callback) {
					window.setTimeout(callback, 1000/60);
				};
			})();
			
			// Draw to the canvas
			function renderCanvas() {
				if (drawing) {		
					ctx.moveTo(lastPos.x, lastPos.y);
					ctx.lineTo(mousePos.x, mousePos.y);
					ctx.stroke();
					lastPos = mousePos;
				}
			}
	
			// Allow for animation
			(function drawLoop () {
				requestAnimFrame(drawLoop);
				renderCanvas();
			})();
	
			// Set up touch events for mobile, etc
			canvas.addEventListener("touchstart", function (e) {
					mousePos = getTouchPos(canvas, e);
			let touch = e.touches[0];
			let mouseEvent = new MouseEvent("mousedown", {
				clientX: touch.clientX,
				clientY: touch.clientY
			});
			canvas.dispatchEvent(mouseEvent);
			}, false);
			canvas.addEventListener("touchend", function (e) {
			let mouseEvent = new MouseEvent("mouseup", {});
			canvas.dispatchEvent(mouseEvent);
			}, false);
			canvas.addEventListener("touchmove", function (e) {
			let touch = e.touches[0];
			let mouseEvent = new MouseEvent("mousemove", {
				clientX: touch.clientX,
				clientY: touch.clientY
			});
			canvas.dispatchEvent(mouseEvent);
			}, false);
	
			// Get the position of a touch relative to the canvas
			function getTouchPos(canvasDom, touchEvent) {
				let rect = canvasDom.getBoundingClientRect();
				return {
					x: touchEvent.touches[0].clientX - rect.left,
					y: touchEvent.touches[0].clientY - rect.top
				};
			}
	
			canvas.addEventListener("touchstart", function(event) {event.preventDefault()});
			canvas.addEventListener("touchmove", function(event) {event.preventDefault()});
			canvas.addEventListener("touchend", function(event) {event.preventDefault()});
			canvas.addEventListener("touchcancel", function(event) {event.preventDefault()});
		});
  }
  
  backToStart() {
    $('.all-legaltext-container').find('.legaltext-page:not(.hidden)').addClass('hidden');
    $('.all-legaltext-container').find('.legaltext-page--0').removeClass('hidden');
  }
}

export default Legaltext;